import { render, staticRenderFns } from "./BannedItem.vue?vue&type=template&id=4b6283fb&scoped=true"
import script from "./BannedItem.vue?vue&type=script&lang=js"
export * from "./BannedItem.vue?vue&type=script&lang=js"
import style0 from "./BannedItem.vue?vue&type=style&index=0&id=4b6283fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6283fb",
  null
  
)

export default component.exports